import { Component, OnInit, Inject } from '@angular/core';
import { ModalService } from '@icc/configurator/shared';
import {
    APP_CONFIG,
    AppConfigFactory,
    UserService,
} from '@icc/shared';
import { PriceDetailsComponent, ProductFeaturesComponent, _, StepComponent } from '@icc/configurator/shared';

@Component({
    selector: 'icc-product-details',
    templateUrl: './product-details.component.html',
    styleUrls: ['./product-details.component.scss'],
    standalone: false
})
export class ProductDetailsComponent extends StepComponent implements OnInit {
    static stepName = _('CONFIGURATOR|Szczegóły');
    static stepIcon = {
        ligature: 'info',
    };

    public configurator = 'window';
    public stepId = 'details';
    public title = _('CONFIGURATOR|Szczegóły');
    public options = [
        {
            title: _('CONFIGURATOR|Szczegóły wyceny'),
            component: PriceDetailsComponent,
            show: () => this.showPriceDetails
        },
        {
            title: _('CONFIGURATOR|Cechy produktów'),
            component: ProductFeaturesComponent,
            show: () => this.showProductFeatures
        }
    ]

    details: any = {};
    priceElementsVisible = false;
    showPriceDetails = false;
    showProductFeatures = true;

    constructor(
        @Inject(APP_CONFIG) private config: AppConfigFactory,
        private modalService: ModalService,
        private userService: UserService
    ) {
        super();
    }

    ngOnInit() {
        const user = this.userService.get();
        this.showPriceDetails = this.config().IccConfig.Configurators.showPriceDetails && user.access == 'producent' && !this.userService.b2c;
         if(this.config().preset === 'b2c') {
            this.showProductFeatures = this.config().IccConfig.Configurators.showProductFeaturesModalB2C;
        }
    }

    openPriceDetails() {
        this.modalService.open({
            pageComponent: PriceDetailsComponent,
        });
    }

}
